import {Component} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {SettingsAmenity} from '../../../types/data.types';
import {DirectoryService} from '../../../services/directory.service';
import {SettingsKeyLogService} from '../../../services/settings-key-log.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'settings-key-log-detailed-view',
    templateUrl: './settings-key-log-detailed-view.component.html',
    styleUrls: ['./settings-key-log-detailed-view.component.scss']
})

export class SettingsKeyLogDetailedViewComponent {
    title = 'Resident';
    disabledFileInput = false;
    data: SettingsAmenity;
    navPosition = 'tab_settings';
    attachments: Array<any> = [];
    noEdit = false;

    constructor(public api: ApiClientService,
                public settingsKeyLogService: SettingsKeyLogService,
                public directoryService: DirectoryService) {
    }

    onSubmit(data: any): void {
        this.noEdit = true;
        const url = `/v1/service_settings/${this.settingsKeyLogService.selectedItemData.id}.json`;
        this.settingsKeyLogService.api.patch('domainKeyLog', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            () => toastr.error('Update failed!'),
            () => this.noEdit = false
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        this.settingsKeyLogService.toggleDetailedView(this.settingsKeyLogService.selectedItemData, true);
        if (close) this.settingsKeyLogService.toggleDetailedView(null, false);
    }

    setEditModeFor(item, fieldName: string, state: boolean) {
        this.setEditModeForAll(false);
        item.formFields[fieldName].editMode = state;
    }

    setEditModeForAll(state: boolean) {
        for(const field in this.settingsKeyLogService.selectedItemData.formFields)
            this.settingsKeyLogService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField) {
        let valueToSend = changedValue;
        if (changedValue.shareContact === 'true')
            valueToSend.shareContact = 1;
        else if (changedValue.shareContact === 'false')
            valueToSend.shareContact = 0;

        if (changedValue.requestType) {
            if (changedValue.requestType.length == 1 && changedValue.requestType != '0')
                valueToSend = {serviceRequestType: changedValue.requestType};
            else
                valueToSend = {serviceRequestTypeOther: changedValue.requestType};
        }

        if (form.dirty) {
            item[formField] = form.value[formField];
            if (form.valid) this.setEditModeForAll(false);
            this.onSubmit(valueToSend);
        } else {
            this.setEditModeForAll(false);
        }
    }

    showNotificationModal(notificationType): void {
        this.settingsKeyLogService.showNotificationsModal = true;
        this.settingsKeyLogService.bookingRequestModalNotificationType = notificationType;
    }

    submitNotificationsField(): void {
        const data = {staffNotificationSettings : [
                {
                    action: 'created',
                    enableStatus: this.settingsKeyLogService.keyCreatedStaffCheckbox,
                    userRoles: this.getUserRolesFormatted(this.settingsKeyLogService.createdStaffMultiselectArray)
                },
                {
                    action: 'deleted',
                    enableStatus: this.settingsKeyLogService.keyDeletedStaffCheckbox,
                    userRoles: this.getUserRolesFormatted(this.settingsKeyLogService.deletedStaffMultiselectArray)
                },
                {
                    action: 'modified',
                    enableStatus: this.settingsKeyLogService.keyModifiedStaffCheckbox,
                    userRoles: this.getUserRolesFormatted(this.settingsKeyLogService.modifiedStaffMultiselectArray)
                },
                {
                    action: 'signed_out',
                    enableStatus: this.settingsKeyLogService.keySignedOutStaffCheckbox,
                    userRoles: this.getUserRolesFormatted(this.settingsKeyLogService.signedOutStaffMultiselectArray)
                },
                {
                    action: 'returned',
                    enableStatus: this.settingsKeyLogService.keyReturnedStaffCheckbox,
                    userRoles: this.getUserRolesFormatted(this.settingsKeyLogService.returnedStaffMultiselectArray)
                }
            ]
        };
        this.onSubmit(data);
    }

    getUserRolesFormatted(arr): Array<any> {
        return arr.map(a => ({bdId: a.id, roleName: a.itemName}));
    }

    changeNavPosition(changeTo): void {
        this.navPosition = changeTo;
    }

    emailTemplateIsSet(action) {
        let flag = false;
        if(this.settingsKeyLogService.selectedItemData.staffNotificationSettings) {
            this.settingsKeyLogService.selectedItemData.staffNotificationSettings.filter((setting) => {
                if (setting.action == action)
                    flag = setting.emailTemplate === null && !setting.emailTemplateOtherMessage && !setting.emailTemplateOtherSubject ? false : true;
            });
        }
        return flag;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-key-log/settings-key-log-detailed-view/settings-key-log-detailed-view.component.ts